<template>
  <div class="top-nav">
    <b-navbar
      toggleable="xl"
      type="dark"
      variant="primary"
    >
      <b-navbar-toggle target="nav_collapse" />
      <b-navbar-brand>
        <router-link
          :to="{ path: '/' }"
          active-class="active"
          exact
        ><img
          :src="require('@/assets/images/InfoAM.png')"
          class="logo"
        ></router-link>
      </b-navbar-brand>
      <b-collapse v-if="this.version && this.loggedInUser" is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item-dropdown text="Sales &amp; CS">
            <b-dropdown-item>
              <router-link :to="{ name: 'Search' }">
                Order Lookup
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'All Orders' }">
                All Unviewed Orders
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Order Pipeline' }">
                Order Pipeline
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Sales by Location' }">
                Sales by Location
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Orders with Product' }">
                Orders with Product
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Awaiting Payment Report' }">
                Awaiting Payment Report
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Shipment Locator' }">
                Shipment Locator
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Notifications' }">
                Email Notifications
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Backordered Part Info' }">
                Backordered Part Info
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('IT')" class='lock-button'>
                <i class="fas fa-fw fa-user-lock"></i>
              </b-button>
              <router-link :to="{ name: 'Locked Orders' }">
                Locked Orders
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Customer Lookup' }">
                Customer Lookup
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Unapproved Tax Forms' }">
                Unapproved Tax Forms
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Happy Customer Report' }">
                Happy Customer Report
              </router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="RMA/HC">
            <b-dropdown-item>
              <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('Returns')" class='lock-button'>
                <i class="fas fa-fw fa-user-lock"></i>
              </b-button>
              <router-link :to="{ name: 'RMA HC', params: { id: 'ORPHAN'} }">
                Create Orphan RMAHC
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Batch RMA HC' }">
                Batch RMAHC
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'RMA Pending Approval' }">
                RMA Pending Approval
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'RMA Pending Receive' }">
                RMA Pending Receive
              </router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Part Info">
            <b-dropdown-item>
              <router-link :to="{ name: 'Qty Calculations' }">
                Inventory Calculations
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                :to="{ name: 'Where Part Is Used' }"
              >Where Part Is Used
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                :to="{ name: 'Part/Product History' }"
              >Part/Product History
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                :to="{ name: 'Part Locator' }"
              >Part Location
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'BOM KIT Info' }">
                BOM & Kit Info
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Deep BOM Info' }">
                Deep BOM & KIT Info
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'BOM KIT Diff' }">
                BOM & Kit Diff Tool
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Inventory Watcher' }">
                Inventory Watcher
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('Part Info')" class='lock-button'>
                <i class="fas fa-fw fa-user-lock"></i>
              </b-button>
              <router-link :to="{ name: 'Product Pricing Sums' }">
                Product Pricing Sums
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('Part Info')" class='lock-button'>
                <i class="fas fa-fw fa-user-lock"></i>
              </b-button>
              <router-link :to="{ name: 'Part Info' }">
                Part Info
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('Part Info')" class='lock-button'>
                <i class="fas fa-fw fa-user-lock"></i>
              </b-button>
              <router-link :to="{ name: 'Part Evaluator' }">
                Part Evaluator
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('Accounting')" class='lock-button'>
                <i class="fas fa-fw fa-user-lock"></i>
              </b-button>
              <router-link :to="{ name: 'Inventory Costing Report' }">
                Inventory Costing Report
              </router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Ops">
            <b-dropdown-item>
              <router-link :to="{ name: 'Operations Report' }">
                Operations Report
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'FIRST Choice Operations Report' }">
                FIRST Choice Operations Report
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Tariff Codes' }">
                Tariff Codes
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'ADV Ineligible' }">
                AM Advantage Ineligible Items
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Inventory Request'}">
                Inventory Request (Took Part)
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Large Item Shipping'}">
                Large Item Shipping
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'FedEx Margin Report' }">
                FedEx Margin Report
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Shipping Server Boxes' }">
                Shipping Server Boxes
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('Ops')" class='lock-button'>
                <i class="fas fa-fw fa-user-lock"></i>
              </b-button>
              <router-link :to="{ name: 'Tracking Number Entry' }">
                Tracking Number Entry
              </router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Manufacturing">
            <b-dropdown-item>
              <router-link :to="{name: 'Manufacturing Request Process'}">
                Manufacturing Request Process and Template
              </router-link>
            </b-dropdown-item>
            <hr/>
            <b-dropdown-item>
              <router-link :to="{name: 'Machine Uptime'}">
                Machine Uptime Report
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{name: 'Router Schedule'}">
                Router Estimated Schedule
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{name: 'Haas Schedule'}">
                Haas Estimated Schedule
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{name: 'Doosan Schedule'}">
                Doosan Estimated Schedule
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{name: 'NC Saw Schedule'}">
                NC Saw Estimated Schedule
              </router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Purchasing">
            <b-dropdown-item>
              <router-link :to="{ name: 'Sales Data' }">
                Sales Data
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('Part Info')" class='lock-button'>
                <i class="fas fa-fw fa-user-lock"></i>
              </b-button>
              <router-link :to="{ name: 'Sales Summary' }">
                Sales Summary
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Purchasing History' }">
                Purchasing History
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                :to="{ name: 'Stock Alarm Products' }">Low/Out of Stock Report
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Buy Sheet' }">
                Buy Sheet
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link :to="{ name: 'Pricing Margin Report' }">
                <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('Part Info')" class='lock-button'>
                  <i class="fas fa-fw fa-user-lock"></i>
                </b-button>
                Pricing Margin Report
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                :to="{ name: 'Past Due Report' }">Past Due Report
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                :to="{ name: 'BOM/Kit Recipe' }">BOM/Kit Recipe
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('Part Info')" class='lock-button'>
                <i class="fas fa-fw fa-user-lock"></i>
              </b-button>
              <router-link :to="{ name: 'PO Report' }">
                PO Report
              </router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="IT">
            <b-dropdown-item>
              <router-link :to="{ name: 'CHAMP Tasks' }">
                CHAMP Tasks
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-button size="sm" variant="link" v-b-popover.hover.bottom="lockMessage('IT')" class='lock-button'>
                <i class="fas fa-fw fa-user-lock"></i>
              </b-button>
              <router-link :to="{ name: 'Query Passthrough' }">
                Query Passthrough
              </router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Office Info">
            <b-dropdown-item>
              <router-link :to="{ name: 'CoffeeNotifier'}">
                Coffee Notifier
              </router-link>
            </b-dropdown-item>
            <a href="https://forms.gle/mYR9mUUqNu89Ui1L6" target="_blank" class="dropdown-item">
              Engineering Change Request Form
            </a>
            <a href="https://forms.gle/woqi2wQvmYpj5Z6y6" target="_blank" class="dropdown-item">
              Large Purchase Request Form
            </a>
          </b-nav-item-dropdown>
          <b-nav-item :to="{ name: 'PackAndShip2' }">
            Pack/Ship Estimator
          </b-nav-item>
          <b-nav-item :to="{ name: 'Fishbowl Data' }">
            Fishbowl Data
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto" v-if="shrinkItems">
          <b-btn variant=link href="https://hammrd.andymark.com" target="_blank" size="sm" v-if="this.version && this.loggedInUser" v-b-popover.hover.bottom="'HAMMRD'">
            <i class="hammrd-icon"></i>
          </b-btn>
          <b-btn variant=link href="https://docusync.andymark.com" target="_blank" size="sm" v-if="this.version && this.loggedInUser" v-b-popover.hover.bottom="'DocuSync'">
            <i class='docusync-icon'></i>
          </b-btn>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto" v-else> <!-- still show names if the navbar is in mobile / collapsed mode -->
          <li class='nav-item mt-2'>
            <a href="https://hammrd.andymark.com" class='nav-link' target="_blank" v-if="this.version && this.loggedInUser">
              HAMMRD
            </a>
          </li>
          <li class='nav-item mt-2'>
            <a href="https://docusync.andymark.com" class='nav-link' target="_blank" v-if="this.version && this.loggedInUser">
              DocuSync
            </a>
          </li>
        </b-navbar-nav>
      </b-collapse>
      <b-navbar-nav class="ml-auto">
        <b-nav-text class="tight">
          <div>version {{version}}</div>
          <div v-html="this.login_status"></div>
        </b-nav-text>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import infoService from '../services/info'
import ScreenSizeMixin from '../screenSize.js';
const BASE_API = process.env.VUE_API_ROOT

export default {
  name: 'TopNavigationBar',
  mounted() {
    axios.get(`${BASE_API}/version`).then((r) => { this.version = r.data })
  },
  mixins: [ ScreenSizeMixin ],
  watch: {
    width() {
      if (!!this.timer) clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        // XL breakpoint
        this.shrinkItems = this.width >= 1200
      }, 150)
    },
  },
  computed: {
    ...mapGetters({
      canAccess: 'canAccess',
      loggedInUser: 'loggedInUser',
      isLoggedIn: 'isLoggedIn',
    }),
    itAccess() {
      return this.$store.getters.canAccess('it-staff')
    },
    login_status() {
      if (this.isLoggedIn && this.shrinkItems) {
        return `Logged In as ${this.loggedInUser['names']['displayName']} <br/> <a href="${this.logout_link}">Log Out</a>`
      } else if (this.isLoggedIn) {
        return `Logged In as ${this.loggedInUser['names']['displayName']} <br/>(${this.loggedInUser.emails.value}) | <a href="${this.logout_link}">Log Out</a>`
      } else {
        return `<a href="${this.login_link}">Log In</a>`
      }
    },
    login_link() {
      if (this.version == 'localdev') {
        return 'http://localhost:5000/google/auth'
      }
      else {
        return '/google/auth'
      }
    },
    logout_link() {
      if (this.version == 'localdev') {
        return 'http://localhost:5000/google/unauth'
      }
      else {
        return '/google/unauth'
      }
    },
  },
  data() {
    return {
      version: '',
      login: '',
      timer: null,
      shrinkItems: false,
      iFramedRoutes: {
        home: '/old-info//',
        inventoryCalculations: '/old-info/AllWebProducts',
        findPartLocation: '/old-info/PartLocator',
        opsInfo: '/old-info/Ops',
        shipmentLocator: '/old-info/ShipmentLocator',
        bomAndKitInfo: '/old-info/BOM_KIT',
        backOrderedInfo: '/old-info/BackOrderParts',
        partInfo: '/old-info/PartInfo',
      },
    }
  },
  methods: {
    lockMessage(role) { return infoService.lockMessage(role, this.itAccess); }
  }
};
</script>

<style sass-scoped>
.logo {
  max-width: 250px;
  transform: rotate(-6.5deg);
  display: none;
}
@media (max-width: 1199px) {
  .logo {
    display: block;
  }
}
@media (min-width: 1700px) {
  .logo {
    display: block;
  }
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 1);
}
.lock-button {
  margin-left: 0px;
  padding-left: 0px;
  padding-right: 0.25rem;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TopNavigationBar.vue